import { useFeatureGate, useStatsigClient } from '@statsig/react-bindings'

/**
 * Safe wrapper for useFeatureGate that handles cases when Statsig client is not available
 * @param {string} gateName - The name of the feature gate
 * @returns {Object} Feature gate result with safe defaults
 */
export const useSafeFeatureGate = (gateName) => {
  const client = useStatsigClient()
  const gate = useFeatureGate(gateName)
  try {
    if (!client) {
      console.warn({ gate, ctx: '[useSafeFeatureGate]', issue: 'no client' })
    }

    return gate
  } catch (error) {
    console.warn({ gate, ctx: '[useSafeFeatureGate]', issue: 'uncaught statsig error', error })
    return gate
  }
}
